export const SET_IS_PENDING = 'rpb2b-react/lists/SET_IS_PENDING';
export type SET_IS_PENDING = typeof SET_IS_PENDING;

export const SET_IS_PENDING_LISTS = 'rpb2b-react/lists/SET_IS_PENDING_LISTS';
export type SET_IS_PENDING_LISTS = typeof SET_IS_PENDING_LISTS;

export const SET_IS_UPDATING = 'rpb2b-react/lists/SET_IS_UPDATING';
export type SET_IS_UPDATING = typeof SET_IS_UPDATING;

export const SET_LISTS = 'rpb2b-react/lists/SET_LISTS';
export type SET_LISTS = typeof SET_LISTS;

export const SET_LIST = 'rpb2b-react/lists/SET_LIST';
export type SET_LIST = typeof SET_LIST;

export const SET_CURRENT_LIST_NUMBER =
  'rpb2b-react/lists/SET_CURRENT_LIST_NUMBER';
export type SET_CURRENT_LIST_NUMBER = typeof SET_CURRENT_LIST_NUMBER;

export const SET_CURRENT_LIST_FAVORITE =
  'rpb2b-react/lists/SET_CURRENT_LIST_FAVORITE';
export type SET_CURRENT_LIST_FAVORITE = typeof SET_CURRENT_LIST_FAVORITE;

export const SET_CURRENT_LIST_NAME = 'rpb2b-react/lists/SET_CURRENT_LIST_NAME';
export type SET_CURRENT_LIST_NAME = typeof SET_CURRENT_LIST_NAME;

export const SET_ITEMS = 'rpb2b-react/lists/SET_ITEMS';
export type SET_ITEMS = typeof SET_ITEMS;

export const ADD_ITEM = 'rpb2b-react/lists/ADD_ITEM';
export type ADD_ITEM = typeof ADD_ITEM;

export const UPDATE_ITEM = 'rpb2b-react/lists/UPDATE_ITEM';
export type UPDATE_ITEM = typeof UPDATE_ITEM;

export const REMOVE_ITEM = 'rpb2b-react/lists/REMOVE_ITEM';
export type REMOVE_ITEM = typeof REMOVE_ITEM;

export const CLEAR_CURRENT_LIST = 'rpb2b-react/lists/CLEAR_CURRENT_LIST';
export type CLEAR_CURRENT_LIST = typeof CLEAR_CURRENT_LIST;

export const SET_ERROR = 'rpb2b-react/lists/SET_ERROR';
export type SET_ERROR = typeof SET_ERROR;

export const SET_SUCCESS = 'rpb2b-react/lists/SET_SUCCESS';
export type SET_SUCCESS = typeof SET_SUCCESS;

export default {
  SET_IS_PENDING,
  SET_IS_PENDING_LISTS,
  SET_IS_UPDATING,
  SET_LISTS,
  SET_LIST,
  SET_CURRENT_LIST_NUMBER,
  SET_CURRENT_LIST_FAVORITE,
  SET_CURRENT_LIST_NAME,
  SET_ITEMS,
  UPDATE_ITEM,
  REMOVE_ITEM,
  CLEAR_CURRENT_LIST,
  SET_ERROR,
  SET_SUCCESS
};
